import { AppThunkAction } from '../reducers';

// Actions
import * as Actions from '../actions';

// Services
import * as service from '../../services/ProtocolConsumptionVisit.Services';
import { ErrorType } from '../../models/HttpError';
import { ProtocolConsumption } from '../../models/Entities/Protocols/ProtocolConsumption';
import { ProtocolConsumptionVisit } from '../../models/Entities/Protocols/ProtocolConsumptionVisit';

type KnownAction =
    | Actions.ProtocolConsumptionVisit.GetAllProtocolVisitRequestAction
    | Actions.ProtocolConsumptionVisit.GetAllProtocolVisitSuccessAction
    | Actions.ProtocolConsumptionVisit.GetAllProtocolVisitFailureAction
    | Actions.ProtocolConsumptionVisit.GetProtocolVisitByIdRequestAction
    | Actions.ProtocolConsumptionVisit.GetProtocolVisitByIdSuccessAction
    | Actions.ProtocolConsumptionVisit.GetProtocolVisitByIdFailureAction
    | Actions.ProtocolConsumptionVisit.GetAllConsumptionsByVisitIdRequestAction
    | Actions.ProtocolConsumptionVisit.GetAllConsumptionsByVisitIdSuccessAction
    | Actions.ProtocolConsumptionVisit.GetAllConsumptionsByVisitIdFailureAction
    | Actions.ProtocolConsumptionVisit.GetVisitConsumptionByStageIdRequestAction
    | Actions.ProtocolConsumptionVisit.GetVisitConsumptionByStageIdSuccessAction
    | Actions.ProtocolConsumptionVisit.GetVisitConsumptionByStageIdFailureAction;


export const actionCreators = {
    GetAllProtocolVisitById:
        (protocolId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'GET_ALL_PROTOCOL_VISITS_FAILURE',
                    protocolId: protocolId,
                    error: {
                        ErrorMessage: 'Not authorized',
                        ErrorCode: 401,
                        Errors: [],
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'GET_ALL_PROTOCOL_VISITS_REQUEST',
                protocolId: protocolId
            });
            
            service
                .GetAllProtocolVisitByProtocolId(protocolId, token)
                .then((protocolVisits) => {
                    dispatch({
                        type: 'GET_ALL_PROTOCOL_VISITS_SUCCESS',
                        protocolId: protocolId,
                        protocolVisits: protocolVisits
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'GET_ALL_PROTOCOL_VISITS_FAILURE',
                        protocolId: protocolId,
                        error: error
                    })
                );
        },
    GetProtocolVisitById:
        (ProtocolId: number, VisitId: string): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'GET_PROTOCOL_VISIT_BYID_FAILURE',
                    protocolId: ProtocolId,
                    error: {
                        ErrorMessage: 'Not authorized',
                        ErrorCode: 401,
                        Errors: [],
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'GET_PROTOCOL_VISIT_BYID_REQUEST',
                protocolId: ProtocolId,
                visitId: VisitId
            });

            service
                .GetProtocolVisitById(token, VisitId)
                .then((visit) => {
                    dispatch({
                        type: 'GET_PROTOCOL_VISIT_BYID_SUCCESS',
                        protocolId: ProtocolId,
                        visit: visit
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'GET_PROTOCOL_VISIT_BYID_FAILURE',
                        protocolId: ProtocolId,
                        error: error
                    })
                );
        },
    GetProtocolVisitByStageId:
        (protocolId: number, stageId: number, patientNumberInProtocol: string): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'GET_VISIT_CONSUMPTION_BY_STAGEID_FAILURE',
                    protocolId: protocolId,
                    stageId: stageId,
                    error: {
                        ErrorMessage: 'Not authorized',
                        ErrorCode: 401,
                        Errors: [],
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'GET_VISIT_CONSUMPTION_BY_STAGEID_REQUEST',
                protocolId: protocolId,
                stageId: stageId
            });

            service
                .GetProtocolVisitByStageId(token, protocolId, stageId, patientNumberInProtocol)
                .then((visit: ProtocolConsumptionVisit) => {
                    dispatch({
                        type: 'GET_VISIT_CONSUMPTION_BY_STAGEID_SUCCESS',
                        protocolId: protocolId,
                        stageId: stageId,
                        visit: visit
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'GET_VISIT_CONSUMPTION_BY_STAGEID_FAILURE',
                        protocolId: protocolId,
                        stageId: stageId,
                        error: error
                    })
                );
        },
    GetAllConsumptionsByVisitId:
        (protocolId: number, stageId: number, patientNumberInProtocol: string): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
           
            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'GET_ALL_CONSUMPTIONS_BY_VISIT_ID_FAILURE',
                    protocolId: protocolId,
                    stageId: stageId,
                    patientNumberInProtocol: patientNumberInProtocol,
                    error: {
                        ErrorMessage: 'Not authorized',
                        ErrorCode: 401,
                        Errors: [],
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'GET_ALL_CONSUMPTIONS_BY_VISIT_ID_REQUEST',
                protocolId: protocolId,
                stageId: stageId,
                patientNumberInProtocol: patientNumberInProtocol
            });

            service
                .GetAllProtocolConsumptionByVisitId(token, protocolId, stageId, patientNumberInProtocol)
                .then((consumptions: ProtocolConsumption[]) => {
                    dispatch({
                        type: 'GET_ALL_CONSUMPTIONS_BY_VISIT_ID_SUCCESS',
                        protocolId: protocolId,
                        stageId: stageId,
                        patientNumberInProtocol: patientNumberInProtocol,
                        consumptions: consumptions
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'GET_ALL_CONSUMPTIONS_BY_VISIT_ID_FAILURE',
                        protocolId: protocolId,
                        stageId: stageId,
                        patientNumberInProtocol: patientNumberInProtocol,
                        error: error
                    })
                );
        },
};

